import ApplicationController from "./application_controller";

export default class extends ApplicationController {
    connect() {
        super.connect()
    }

    toggleRadioButton(event) {
        const radio = event.target;
        document.querySelectorAll(`input[type="radio"][name="${CSS.escape(radio.name)}"]`).forEach(r => {
            const label = document.querySelector(`label[for="${r.id}"]`);
            if (!label) return;
            if (r.checked) {
                label.classList.add('toggle-option-selected');
                label.classList.remove('toggle-option-unselected');
            } else {
                label.classList.remove('toggle-option-selected');
                label.classList.add('toggle-option-unselected');
            }
        });

        const questionId = radio.dataset.questionId;
        if (questionId && radio.dataset.childrenRequired === "true") {
            const section = document.getElementById(questionId);
            if (!section) return;
            const makeRequired = radio.value === "true";
            section.querySelectorAll('input, textarea, select').forEach(input => {
                input.required = makeRequired;
                input.disabled = !makeRequired;
            });
        }
    }

    toggleEmployerRequired(event) {
        const isRequired = event.target.value.trim() === "";
        ["quote[aui][employer]", "quote[aui][jobTitle]"].forEach((fieldName) => {
            const field = this.element.querySelector(`[name="${fieldName}"]`);
            if (!field) return;
            field.required = isRequired;
        });
    }

    toggleAllCheckboxes(event) {
        const checkboxes = document.getElementsByName("quote[item_ids][]");

        checkboxes.forEach((i) => {
            if (!i.disabled) {
                i.checked = event.target.checked
            }
        });
    }

    async overridePremium(event) {
        event.preventDefault();
        const step = this._step(event);
        const quoteId = this._quoteId(event);
        if (document.getElementById("override-field").value !== null) {
            await this.stimulate("QuoteFlowReflex#override_premium", quoteId, step)
        }
        if (step === "step_five") {
            this.notifyPaymentMethodSelected(event);
        }
    }

    notifyPaymentMethodSelected(event) {
        const paymentSelect = document.getElementById("payment-method-input");
        if (!paymentSelect) return;
        const quoteId = this._quoteId(event) ?? paymentSelect.dataset.quoteId;
        if (quoteId) {
            this.stimulate("QuoteFlowReflex#notify_payment_method_selected", quoteId, paymentSelect.value);
        }
    }

    submit(event) {
        if (this._submitting) {
            event.preventDefault();
            return;
        }
        this._submitting = true;
        this._disableSubmitButton();
        this._displayStepSpinner();
        this._showOverlayWhileSubmitting();
        this._showPleaseWaitModal();
    }

    _disableSubmitButton() {
        // Fake the disabled look/feel via classes instead of the `disabled` attribute:
        // a disabled submit button is excluded from the form's data on submission,
        // which would drop `quote[action]` (see usa_step_four_component's two submit buttons).
        this.element.querySelectorAll('[type="submit"]').forEach(btn => {
            btn.setAttribute('aria-disabled', 'true');
            btn.classList.add('pointer-events-none', 'opacity-50', 'cursor-not-allowed');
        });
    }

    _showOverlayWhileSubmitting() {
        document.getElementById("submit-overlay")?.classList.remove("hidden");
    }

    // Nothing hides it again: the response replaces the page it is on.
    _showPleaseWaitModal() {
        const modal = document.getElementById("please-wait-modal");
        if (!modal) return;

        modal.classList.remove("hidden");
        modal.focus();
    }

    _displayStepSpinner() {
        document.getElementById("step-spinner")?.classList.remove("hidden")
    }

    _step(event) {
        return event.target.dataset.step;
    }

    _quoteId(event) {
        return event?.target?.dataset?.quoteId;
    }
}